module.exports = __webpack_public_path__ + "img/direct-download.893cd17d.svg";